import React, { useEffect } from "react";
import "./AllCampaign.css";
import { useDispatch, useSelector } from "react-redux";
import { allCampaignData } from "../../features/allCampaign/allCampaignSlice";
import { Delete, Edit, ToggleOff, ToggleOn } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { getCampaignByIdData } from "../../features/getCampaignById/getCampaignByIdSlice";
import { deleteCampaignByIdData } from "../../features/deleteCampaign/deleteCampaignSlice";
import { campaignDetailData } from "../../features/campaignDetail/campaignDetailSlice";
import { toggleCampaignByIdData } from "../../features/toggleCampaign/toggleCampaignSlice";

const AllCampaign = () => {
  let pathname = window.location.pathname;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allcampaignList = useSelector((state) => state.allCampaign.data.data);
  const allcampaignpending = useSelector((state) => state.allCampaign.pending);
  const allcampaignerror = useSelector((state) => state.allCampaign.error);

  // console.log(allcampaignList)

  useEffect(() => {
    
      dispatch(allCampaignData());
    
    
  },[]);

  const handleEditClick = (e, id) => {
    e.stopPropagation();
    const campaignId = id;
    dispatch(getCampaignByIdData(campaignId)).then((res) => {
      console.log(res);
    });
  };

  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    const campaignId = id;
    dispatch(deleteCampaignByIdData(campaignId)).then((res) => {
      console.log(res);
    });
  };

  const handleToggleClick = (e, id) => {
    e.stopPropagation();
    const campaignId = id;
    dispatch(toggleCampaignByIdData(campaignId)).then((res) => {
      console.log(res);
    });
  };

  const handleClick = (id) => {
    const campaignId = id;
    dispatch(campaignDetailData(campaignId)).then((res) => {
      console.log(res);
    });
    navigate("/admin/campaign-detail");
    // window.location.href = 'http://localhost:3000/admin/campaign-detail'
  };

  return (
    <div className="allCampaign">
      <div className="allCampaignWrapper">
        <h3>ALL CAMPAIGN </h3>
        <div className="allCampaignTableWrapper">
          <table className="allCampaignTable">
            <tr>
              {/* <th>
                Title
              </th> */}
              <th>Action</th>
              <th>Company Name</th>
              <th>Banner Ad status</th>
              <th>Footer Ad status</th>
              <th>Interstitial Ad status</th>
              <th>Status</th>
            </tr>

            {allcampaignList?.map((Campaign, i) => {
              return (
                <tr key={i} onClick={() => handleClick(Campaign._id)}>
                  {/* <tr key = {i} onClick={()=>handleClick(Campaign._id)} > */}

                  <td>
                    <div className="action">
                      <Link
                        to="/admin/edit-campaign"
                        className="edit"
                        onClick={(e) => handleEditClick(e, Campaign._id)}
                      >
                        <Edit className="editCampaignIcon" />
                        Edit
                      </Link>
                      <Link
                        to="/admin/all-campaign"
                        className="delete"
                        onClick={(e) => handleDeleteClick(e, Campaign._id)}
                      >
                        <Delete className="editCampaignIcon" />
                        Delete
                      </Link>
                    </div>
                  </td>

                  <td className="companyName">{Campaign?.companyName}</td>
                  <td className="Adstatus ">
                    <div className="statusWrapper">
                      {Campaign?.ads[0]?.bannerAds?.status === "Active" &&
                      allcampaignList[i].status === true ? (
                        <h6>
                          <div className="icon"></div>Active
                        </h6>
                      ) : (
                        <h6>
                          <div className="redDot"></div>Inactive
                        </h6>
                      )}
                    </div>
                    <br />{" "}
                    <p>
                      {"start date :"}{" "}
                      {Campaign?.ads[0]?.bannerAds?.startDate
                        ? moment(Campaign?.ads[0]?.bannerAds?.startDate).format(
                            "DD-MM-YYYY"
                          )
                        : ""}
                    </p>
                    <br />
                    <p>
                      {"End date :"}{" "}
                      {Campaign?.ads[0]?.bannerAds?.endDate
                        ? moment(Campaign?.ads[0]?.bannerAds?.endDate).format(
                            "DD-MM-YYYY"
                          )
                        : ""}
                    </p>
                  </td>
                  <td className="Adstatus ">
                    <div className="statusWrapper">
                      {Campaign?.ads[0]?.footerAds?.status === "Active" &&
                      allcampaignList[i].status === true ? (
                        <h6>
                          <div className="icon"></div>Active
                        </h6>
                      ) : (
                        <h6>
                          <div className="redDot"></div>Inactive
                        </h6>
                      )}
                    </div>
                    <br />{" "}
                    {Campaign?.ads[0]?.footerAds?.status === "Active" ? (
                      <div>
                        <p>
                          {"start date :"}{" "}
                          {Campaign?.ads[0]?.footerAds?.startDate
                            ? moment(
                                Campaign?.ads[0]?.footerAds?.startDate
                              ).format("DD-MM-YYYY")
                            : ""}
                        </p>
                        <br />
                        <p>
                          {"End date :"}{" "}
                          {Campaign?.ads[0]?.footerAds?.endDate
                            ? moment(
                                Campaign?.ads[0]?.footerAds?.endDate
                              ).format("DD-MM-YYYY")
                            : ""}
                        </p>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {/* {Campaign?.ads[0]?.footerAds?.status === 'Active' ? 'Active':'Inactive'} */}
                  </td>
                  <td className="Adstatus ">
                    <div className="statusWrapper">
                      {Campaign?.ads[0]?.interstitialAds?.status === "Active" &&
                      allcampaignList[i].status === true ? (
                        <h6>
                          <div className="icon"></div>Active
                        </h6>
                      ) : (
                        <h6>
                          <div className="redDot"></div>Inactive
                        </h6>
                      )}
                    </div>
                    <br />{" "}
                    {Campaign?.ads[0]?.interstitialAds?.status === "Active" ? (
                      <div>
                        <p>
                          {"start date :"}{" "}
                          {Campaign?.ads[0]?.interstitialAds?.startDate
                            ? moment(
                                Campaign?.ads[0]?.interstitialAds?.startDate
                              ).format("DD-MM-YYYY")
                            : ""}
                        </p>
                        <br />
                        <p>
                          {"End date :"}{" "}
                          {Campaign?.ads[0]?.interstitialAds?.endDate
                            ? moment(
                                Campaign?.ads[0]?.interstitialAds?.endDate
                              ).format("DD-MM-YYYY")
                            : ""}
                        </p>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {/* {Campaign?.ads[0]?.interstitialAds?.status ==='Active' ? 'Active':'Inactive'} */}
                  </td>
                  <td>
                    <div className="status">
                      <Link
                        to="/admin/all-campaign"
                        className="toggleCampaign"
                        onClick={(e) => handleToggleClick(e, Campaign._id)}
                      >
                        {allcampaignList[i].status === true ? (
                          <div className="campaignToggle">
                            <ToggleOn className="toggleOnCampaignIcon" />
                            Active
                          </div>
                        ) : (
                          <div className="campaignToggle">
                            <ToggleOff className="toggleOffCampaignIcon" />
                            InActive
                          </div>
                        )}
                      </Link>
                    </div>
                  </td>
                  {/* <td >
                <div className="action">
                <Link to = '/admin/edit-campaign' className='edit' onClick={(e)=>handleEditClick(e,Campaign._id)}><Edit className='editCampaignIcon'/>Edit</Link><Link to = '/admin/all-campaign' className='delete' onClick={()=>handleDeleteClick(Campaign._id)}><Delete className='editCampaignIcon'/>Delete</Link>
                </div>
                
                
              </td> */}
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllCampaign;
